export default __webpack_public_path__ + "static/Continuous Integration 5-8cdf18d520792b7e3e5c50742e91275c.png";